import { createSelector } from '@opengov/compose-app/reselect';
import * as qs from 'query-string';

import { matchRoute, routerSelector } from '../state';
import { ILocation } from '../types';

export const getBasename = state => state.get('basename');
export const getParams = state => state.get('params');
export const getPathname = state => state.get('pathname');
export const getPreviousRoute = state => state.get('previous');
export const getOrigin = state => state.get('origin');
export const getQuery = state => state.get('query');
export const getSearch = state => state.get('search');

export const getLocation = createSelector(
  routerSelector,
  state => state.location
);

export const getParam = createSelector(
  (_, param: string) => param,
  getLocation,
  (param, location) => location && location.params[param]
);

export const getQueryParams = createSelector(
  getQuery,
  queryString => qs.parse(queryString)
);

export const getCurrentRouteMatch = createSelector(
  routerSelector,
  state => (location: ILocation) => matchRoute(state.routes, location)
);

export const isRouterReady = createSelector(
  routerSelector,
  state => state.ready
);

export const getPreviousLocation = createSelector(
  routerSelector,
  state => state.previous
);
export const getCurrentPathname = createSelector(
  getLocation,
  location => location && location.pathname
);

export const getResult = createSelector(
  getLocation,
  location => location && location.result
);
export const getRouteTitle = createSelector(
  getResult,
  state => state,
  (route, state): string => {
    const title = route && route.title;
    if (!title) {
      return '';
    }

    return typeof title === 'function' ? title(state) : title;
  }
);

export const getRouteSelector = createSelector(
  getResult,
  route => route && route.selector
);

export const getRouteComponent = createSelector(
  getResult,
  route => route && route.component
);

export const getRouteProps = createSelector(
  getRouteSelector,
  state => state,
  (selector, state) => (selector ? selector(state) : {})
);

export const getRouteName = createSelector(
  getResult,
  route => route && route.name
);
